import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const api = buildService(`/nasu-svc/service`);

export const mockOCRMaxRolloverAmountCall = {
  calcStatus: 'calc_success',
  withdrawalCalcMessages: [],
  hasCompanyStock: null,
  hasRothHoldings: null,
  consumerName: null,
  uniqueKey: null,
  afterTaxBasisAmount: 0,
  hasAfterTaxHoldings: null,
  maxRolloverAmount: 169897.65,
  paperWorkRequired: true
};

export const getRPSOCRMaxRolloverAmountService = async (
  ssn: string | undefined,
  rpsChosenPlan: string | undefined
): Promise<any> => {
  if (settings['mockedMode']) return mockOCRMaxRolloverAmountCall;
  const errorCodes = [204, 404, 403, 500];

  return api.http.post(
    '/ocr-customer/ocr-amounts',
    {
      ssn,
      planNumber: rpsChosenPlan
    },
    { errorCodes, ignoreServiceFailure: true }
  );
};

export default api;
